import angular from 'angular';

import 'angular-ui-router';

import forgotUsernameComponent from './forgotUsername.component';

import commonModule from '../../common';

export default angular.module('fp:customerportal:login:forgotpassword', [
        'ui.router',

        commonModule.name
])

    .config(/*@ngInject*/ ($stateProvider) => {
        $stateProvider
            .state('login.forgot-username',
            {
                url: '/forgotUsername',
                template: '<fp-forgot-username></fp-forgot-username>'
            });
    })

    .component('fpForgotUsername', forgotUsernameComponent);